module.exports = __webpack_public_path__ + "static/media/5mm_for_legend.7078f086.png";